import React, { useContext, useEffect } from 'react'
import { useHistory, Link } from 'react-router-dom'
import { Button, Divider } from '@material-ui/core'
import { handleRedirectInternal } from '@/product/common/components'
import AuthContext from '@/product/context/auth/authContext'
import { useTranslation } from 'react-i18next'
import LoginComponent from './loginComponent'
import { loginSchema } from './loginSchema'
import SEO from '@/utils/SEO'
import './Login.css'
//login page
const Login = () => {
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const vData = loginSchema()
    //useTranslation for language change functionality

    const { isAuthenticated } = authContext

    const handleredirection = () => {
        // handleRedirectInternal(history, 'search')
    }
    //authcontext===>user authentication
    useEffect(() => {
        if (isAuthenticated) {
            handleredirection()
        }
    }, [isAuthenticated])

    return (
        <>
            <SEO title="Login" url={window.location.href} />
            <div className="loginCnt">
                <div className="login loginLt">
                    <h1>SIGN IN</h1>
                    <h2>You can Sign In to your account here.</h2>
                    <LoginComponent
                        initialValues={vData.initialValues}
                        validationArray={vData.validationArray}
                        rememberMe={true}
                        loginInfo={vData.login.formData}
                        onSuccess={handleredirection}
                    />
                </div>
                <div className="loginRt">
                    <h3>New here?</h3>
                    <p>Sign up and create your Account</p>
                    <Button onClick={() => handleRedirectInternal(history, 'registration')}>
                        Sign Up
                    </Button>
                </div>
            </div>
        </>
    )
}

export default Login
